import PropTypes from 'prop-types'

export default PropTypes.arrayOf(
  PropTypes.shape({
    type: PropTypes.string.isRequired,
    active: PropTypes.bool
  })
).isRequired
